import { getOrdersByCertificationPeriodOptions, OrderStatusEnum } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Plus } from 'lucide-react';
import { StartOrderFormModal } from './StartDraftOrderFormModal';
import { OrdersTable } from './OrdersTable';
import { Button } from '~/shared/components/buttons/Button';

export function PatientOrders({ stayId, certificationPeriodId }: { stayId: string; certificationPeriodId: string }) {
	const { data: orders } = useSuspenseQuery({
		...getOrdersByCertificationPeriodOptions(certificationPeriodId)
	});

	const draftOrders = orders?.filter(o => o.orderStatusId === OrderStatusEnum.Drafted) || [];
	const nonDraftOrders =
		orders?.filter(o => o.orderStatusId !== OrderStatusEnum.Drafted).toSorted((a, b) => a.orderDate.getTime() - b.orderDate.getTime()) || [];

	return (
		<div className="space-y-8">
			<div className="grid grid-cols-1 gap-2">
				<div className="flex items-center justify-between">
					<span className="text-base text-gray-500">Drafted Orders</span>
					<Button
						Icon={Plus}
						aria-label="Add/Create Order"
						intent="neutral"
						useSuspense
						renderModal={closeModal => (
							<StartOrderFormModal stayId={stayId} certificationPeriodId={certificationPeriodId} closeModal={closeModal} />
						)}
					/>
				</div>

				<OrdersTable rows={draftOrders} />
			</div>
			<div className="grid grid-cols-1 gap-2">
				<span className="text-base text-gray-500">Orders</span>
				<OrdersTable rows={nonDraftOrders} />
			</div>
		</div>
	);
}
